class Utils {

    static getRequiredHeaders () {
        return {
            "token-id": localStorage.getItem('token_id'),
            "user-id": localStorage.getItem('luser_id'),
            "device-type": 'AML9327483'
        }
    }

}

export default Utils;


// WEBPACK FOOTER //
// ./src/utils/utils.js